import { useQueryClient, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useCallback } from "react";
import { ActivationPopupsExperimentalTemplatesConfiguration } from "api/models";
import { useNotifications, useQueryConfig, useSelectedShop } from "shared/hooks";
import { useErrorFormatter } from "shared/utils";
import { NetworkError } from "shared/types";
import { putActivationPopupsExperimentalTemplatesConfiguration } from "../../api";

export const useEnableActivationPopupsExperimentalTemplatesConfiguration = () => {
  const { queryName } = useQueryConfig();

  const { selectedShopId } = useSelectedShop();

  const queryClient = useQueryClient();

  const formatError = useErrorFormatter();

  const { showNotification } = useNotifications();

  const { mutateAsync: enableActivationPopupsExperimentalTemplatesConfiguration } = useMutation<
    void,
    AxiosError<{ message: string }>,
    ActivationPopupsExperimentalTemplatesConfiguration & { shopId: number }
  >(putActivationPopupsExperimentalTemplatesConfiguration);

  const executeEnableActivationPopupsExperimentalTemplatesConfiguration = useCallback(async () => {
    try {
      await enableActivationPopupsExperimentalTemplatesConfiguration({
        experimentalTemplatesEnabled: true,
        shopId: selectedShopId!
      });

      queryClient.invalidateQueries([queryName, selectedShopId]);

      showNotification(
        "featuresModule.activationPopups.administrationBlock.activatedMessage",
        "success"
      );
    } catch (error) {
      return formatError(error as NetworkError);
    }
  }, [queryName, selectedShopId, showNotification]);

  return executeEnableActivationPopupsExperimentalTemplatesConfiguration;
};
